/**
 * SmartRural Sync API
 * API para sincronizar los datos de Smartrural entre la aplciación móvil y el servidor.
 *
 * OpenAPI spec version: 1.1.6
 * Contact: victor@aidiapp.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CustomReport } from '../model/customReport';
import { CustomReportReadOnly } from '../model/customReportReadOnly';
import { DiseaseReport } from '../model/diseaseReport';
import { InlineResponse2001 } from '../model/inlineResponse2001';
import { InlineResponse2002 } from '../model/inlineResponse2002';
import { InlineResponse2003 } from '../model/inlineResponse2003';
import { MaintenanceReport } from '../model/maintenanceReport';
import { MaintenanceReportReadOnly } from '../model/maintenanceReportReadOnly';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { DiseaseReportReadOnly } from '..';


@Injectable()
export class ReportsService {

 private cachedEntitiesResult: any;
 protected basePath = 'https://api.smartrural.es:8084/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Upload a custom report
     *
     * @param customresports Custom report data and user authentication
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customreport(customresports: Array<CustomReport>, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomReportReadOnly>>;
    public customreport(customresports: Array<CustomReport>, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomReportReadOnly>>>;
    public customreport(customresports: Array<CustomReport>, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomReportReadOnly>>>;
    public customreport(customresports: Array<CustomReport>, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customresports === null || customresports === undefined) {
            throw new Error('Required parameter customresports was null or undefined when calling customreport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<CustomReportReadOnly>>(`${this.basePath}/reports/customreport`,
            customresports,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download maintenance reports list
     *
     * @param page Pagina de la que se quiere obtener el listado de reportes
     * @param authorization Access token in the format Bearer token
     * @param datefrom Fecha desde la que se quieren filtrar los resultados
     * @param dateto Fecha hasta la que se quieren filtrar los resultados
     * @param field parcela de la que se quieren filtrar los resultados
     * @param user Usuario del que se quieren filtrar los resultados
     * @param modulename Modulo del que se quieren filtrar los resultados
     * @param form Formulario del que se quieren filtrar los resultados
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customreportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, field?: number, user?: number, modulename?: string, form?: number, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2003>;
    public customreportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, field?: number, user?: number, modulename?: string, form?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2003>>;
    public customreportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, field?: number, user?: number, modulename?: string, form?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2003>>;
    public customreportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, field?: number, user?: number, modulename?: string, form?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling customreportlist.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (datefrom !== undefined && datefrom !== null) {
            queryParameters = queryParameters.set('datefrom', <any>datefrom.toISOString());
        }
        if (dateto !== undefined && dateto !== null) {
            queryParameters = queryParameters.set('dateto', <any>dateto.toISOString());
        }
        if (field !== undefined && field !== null) {
            queryParameters = queryParameters.set('field', <any>field);
        }
        if (user !== undefined && user !== null) {
            queryParameters = queryParameters.set('user', <any>user);
        }
        if (modulename !== undefined && modulename !== null) {
            queryParameters = queryParameters.set('modulename', <any>modulename);
        }
        if (form !== undefined && form !== null) {
            queryParameters = queryParameters.set('form', <any>form);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InlineResponse2003>(`${this.basePath}/reports/customreportlist/${encodeURIComponent(String(page))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upload a disease report
     *
     * @param diseases Disease report data and user authentication
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public diseasereport(diseases: Array<DiseaseReport>, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DiseaseReport>>;
    public diseasereport(diseases: Array<DiseaseReport>, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DiseaseReport>>>;
    public diseasereport(diseases: Array<DiseaseReport>, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DiseaseReport>>>;
    public diseasereport(diseases: Array<DiseaseReport>, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (diseases === null || diseases === undefined) {
            throw new Error('Required parameter diseases was null or undefined when calling diseasereport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<DiseaseReport>>(`${this.basePath}/reports/diseasereport`,
            diseases,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download disease reports list
     *
     * @param page Pagina de la que se quiere obtener el listado de reportes
     * @param authorization Access token in the format Bearer token
     * @param datefrom Fecha desde la que se quieren filtrar los resultados
     * @param dateto Fecha hasta la que se quieren filtrar los resultados
     * @param disease Enfermedad de la que se quieren filtrar los resultados
     * @param user Usuario del que se quieren filtrar los resultados
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public diseasereportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, disease?: number, user?: number, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2001>;
    public diseasereportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, disease?: number, user?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2001>>;
    public diseasereportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, disease?: number, user?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2001>>;
    public diseasereportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, disease?: number, user?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling diseasereportlist.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (datefrom !== undefined && datefrom !== null) {
            queryParameters = queryParameters.set('datefrom', <any>datefrom.toISOString());
        }
        if (dateto !== undefined && dateto !== null) {
            queryParameters = queryParameters.set('dateto', <any>dateto.toISOString());
        }
        if (disease !== undefined && disease !== null) {
            queryParameters = queryParameters.set('disease', <any>disease);
        }
        if (user !== undefined && user !== null) {
            queryParameters = queryParameters.set('user', <any>user);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InlineResponse2001>(`${this.basePath}/reports/diseasereportlist/${encodeURIComponent(String(page))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download maintenance reports list
     *
     * @param page Pagina de la que se quiere obtener el listado de reportes
     * @param authorization Access token in the format Bearer token
     * @param datefrom Fecha desde la que se quieren filtrar los resultados
     * @param dateto Fecha hasta la que se quieren filtrar los resultados
     * @param maintenance Mantenimiento del que se quieren filtrar los resultados
     * @param user Usuario del que se quieren filtrar los resultados
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public maintenanceportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, maintenance?: number, user?: number, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2002>;
    public maintenanceportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, maintenance?: number, user?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2002>>;
    public maintenanceportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, maintenance?: number, user?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2002>>;
    public maintenanceportlist(page: number, authorization?: string, datefrom?: Date, dateto?: Date, maintenance?: number, user?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling maintenanceportlist.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (datefrom !== undefined && datefrom !== null) {
            queryParameters = queryParameters.set('datefrom', <any>datefrom.toISOString());
        }
        if (dateto !== undefined && dateto !== null) {
            queryParameters = queryParameters.set('dateto', <any>dateto.toISOString());
        }
        if (maintenance !== undefined && maintenance !== null) {
            queryParameters = queryParameters.set('maintenance', <any>maintenance);
        }
        if (user !== undefined && user !== null) {
            queryParameters = queryParameters.set('user', <any>user);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<InlineResponse2002>(`${this.basePath}/reports/maintenancereportlist/${encodeURIComponent(String(page))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upload a maintenance report
     *
     * @param maintenances Maintenance report data and user authentication
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public maintenancereport(maintenances: Array<MaintenanceReport>, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MaintenanceReportReadOnly>>;
    public maintenancereport(maintenances: Array<MaintenanceReport>, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MaintenanceReportReadOnly>>>;
    public maintenancereport(maintenances: Array<MaintenanceReport>, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MaintenanceReportReadOnly>>>;
    public maintenancereport(maintenances: Array<MaintenanceReport>, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (maintenances === null || maintenances === undefined) {
            throw new Error('Required parameter maintenances was null or undefined when calling maintenancereport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<MaintenanceReportReadOnly>>(`${this.basePath}/reports/maintenancereport`,
            maintenances,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public saveEntitiesToCache(entities: any){
      this.cachedEntitiesResult = entities;
    }

    public getCachedEntitiesResult(){
      return this.cachedEntitiesResult;
    }

    /**
     * Delete (deactivate) custom report
     *
     * @param idreport Id de reporte a eliminar
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public deletecustomreport(idreport: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomReportReadOnly>;
     public deletecustomreport(idreport: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomReportReadOnly>>;
     public deletecustomreport(idreport: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomReportReadOnly>>;
     public deletecustomreport(idreport: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idreport === null || idreport === undefined) {
             throw new Error('Required parameter idreport was null or undefined when calling deletecustomreport.');
         }


         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.delete<CustomReportReadOnly>(`${this.basePath}/reports/customreport/${encodeURIComponent(String(idreport))}`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * Delete (deactivate) dise
      *
      * @param idreport Id de reporte a eliminar
      * @param authorization Access token in the format Bearer token
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public deletediseasereport(idreport: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<DiseaseReportReadOnly>;
     public deletediseasereport(idreport: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DiseaseReportReadOnly>>;
     public deletediseasereport(idreport: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DiseaseReportReadOnly>>;
     public deletediseasereport(idreport: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idreport === null || idreport === undefined) {
             throw new Error('Required parameter idreport was null or undefined when calling deletediseasereport.');
         }


         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.delete<DiseaseReportReadOnly>(`${this.basePath}/reports/diseasereport/${encodeURIComponent(String(idreport))}`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * Delete (deactivate) maintenance
      *
      * @param idreport Id de reporte a eliminar
      * @param authorization Access token in the format Bearer token
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public deletemaintenancereport(idreport: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<MaintenanceReportReadOnly>;
     public deletemaintenancereport(idreport: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MaintenanceReportReadOnly>>;
     public deletemaintenancereport(idreport: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MaintenanceReportReadOnly>>;
     public deletemaintenancereport(idreport: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idreport === null || idreport === undefined) {
             throw new Error('Required parameter idreport was null or undefined when calling deletemaintenancereport.');
         }


         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.delete<MaintenanceReportReadOnly>(`${this.basePath}/reports/maintenancereport/${encodeURIComponent(String(idreport))}`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
     * Update custom report
     *
     * @param idreport Id de reporte a editar
     * @param customreport Custom report data
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatecustomreport(idreport: number, customreport: CustomReport, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomReportReadOnly>;
    public updatecustomreport(idreport: number, customreport: CustomReport, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomReportReadOnly>>;
    public updatecustomreport(idreport: number, customreport: CustomReport, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomReportReadOnly>>;
    public updatecustomreport(idreport: number, customreport: CustomReport, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idreport === null || idreport === undefined) {
            throw new Error('Required parameter idreport was null or undefined when calling updatecustomreport.');
        }

        if (customreport === null || customreport === undefined) {
            throw new Error('Required parameter customreport was null or undefined when calling updatecustomreport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CustomReportReadOnly>(`${this.basePath}/reports/customreport/${encodeURIComponent(String(idreport))}`,
            customreport,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update disease report
     *
     * @param idreport Id de reporte a editar
     * @param disease Disease report data
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatediseasereport(idreport: number, disease: DiseaseReport, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<DiseaseReportReadOnly>;
    public updatediseasereport(idreport: number, disease: DiseaseReport, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DiseaseReportReadOnly>>;
    public updatediseasereport(idreport: number, disease: DiseaseReport, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DiseaseReportReadOnly>>;
    public updatediseasereport(idreport: number, disease: DiseaseReport, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idreport === null || idreport === undefined) {
            throw new Error('Required parameter idreport was null or undefined when calling updatediseasereport.');
        }

        if (disease === null || disease === undefined) {
            throw new Error('Required parameter disease was null or undefined when calling updatediseasereport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<DiseaseReportReadOnly>(`${this.basePath}/reports/diseasereport/${encodeURIComponent(String(idreport))}`,
            disease,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update maintenance report
     *
     * @param idreport Id de reporte a editar
     * @param maintenance Maintenance report data
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatemaintenancereport(idreport: number, maintenance: MaintenanceReport, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<MaintenanceReportReadOnly>;
    public updatemaintenancereport(idreport: number, maintenance: MaintenanceReport, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MaintenanceReportReadOnly>>;
    public updatemaintenancereport(idreport: number, maintenance: MaintenanceReport, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MaintenanceReportReadOnly>>;
    public updatemaintenancereport(idreport: number, maintenance: MaintenanceReport, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idreport === null || idreport === undefined) {
            throw new Error('Required parameter idreport was null or undefined when calling updatemaintenancereport.');
        }

        if (maintenance === null || maintenance === undefined) {
            throw new Error('Required parameter maintenance was null or undefined when calling updatemaintenancereport.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<MaintenanceReportReadOnly>(`${this.basePath}/reports/maintenancereport/${encodeURIComponent(String(idreport))}`,
            maintenance,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
